module.exports = __webpack_public_path__ + "img/loading.8bef2d23.gif";